import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DataSummarySectionWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${Spacing.S12} ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey100};
`
